import React from "react";
import { useNavigate } from "react-router-dom";

const Unauthorized = () => {
  const navigate = useNavigate();

  return (
    <div className="container text-center" style={{ padding: "50px 0" }}>
      <h1 className="display-1">403</h1>
      <h2 className="mb-4">Unauthorized Access</h2>
      <p className="lead">You do not have permission to access this page.</p>
      <button
        className="btn btn-primary mt-3"
        onClick={() => navigate("/home")}
      >
        Return to Home
      </button>
    </div>
  );
};

export default Unauthorized;
